var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 962.73 803.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "242.73 413.67 242.73 581.07 467.73 703.92 692.73 581.07 692.73 413.67 467.73 536.52 242.73 413.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.83 266.52 467.73 433.92 774.63 266.52 467.73 99.12 160.83 266.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.74,3.06L13.05,244.52c-17.4,9.49-17.4,34.48,0,43.97l126.61,69c8.05,4.39,13.06,12.82,13.06,21.99v240.27c0,9.16,5,17.59,13.05,21.98l289.96,158.23c7.48,4.08,16.51,4.08,23.99,0l289.96-158.23c8.04-4.39,13.05-12.82,13.05-21.98v-240.27c0-9.17,5.01-17.6,13.06-21.99l39.92-21.75c16.69-9.09,37.03,2.98,37.03,21.99v243.74c0,13.83,11.21,25.04,25.04,25.04h39.92c13.83,0,25.04-11.21,25.04-25.04v-320.09c0-9.16-5.01-17.6-13.05-21.98L479.72,3.06c-7.47-4.08-16.51-4.08-23.98,0ZM679.69,588.19l-199.96,109.18c-7.48,4.08-16.52,4.08-24,0l-199.96-109.18c-8.04-4.39-13.04-12.82-13.04-21.98v-110.34c0-19.01,20.35-31.09,37.04-21.98l175.96,96.07c7.48,4.08,16.52,4.08,24,0l175.96-96.07c16.69-9.11,37.04,2.97,37.04,21.98v110.34c0,9.16-5,17.59-13.04,21.98ZM455.74,427.38l-254.61-138.88c-17.4-9.49-17.4-34.48,0-43.97l254.61-138.88c7.47-4.08,16.51-4.08,23.98,0l254.61,138.88c17.4,9.49,17.4,34.48,0,43.97l-254.61,138.88c-7.47,4.08-16.51,4.08-23.98,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.cd439f7833d79542d69d898d2108ac0b.svg";
export { ForwardRef as ReactComponent };